import { call, put, takeEvery } from "redux-saga/effects";
import {
  executeReportsError,
  executeReportsSuccess,
  reportExportExcelError,
  reportExportExcelSuccess,
  reportsError,
  reportsSuccess,
} from "./actions";
import {
  EXECUTE_REPORT,
  POST_REPORTS,
  REPORT_EXPORT_EXCEL,
} from "./actionTypes";
import {
  executeReportsPostApi,
  reportExportExcelApi,
  reportsPostApi,
} from "../../resources/helper/reportsHelpers";

function* reportsPost({ payload: { reportsBody } }) {
  try {
    const response = yield call(reportsPostApi, reportsBody);
    yield put(reportsSuccess(response));
  } catch (error) {
    yield put(reportsError(error));
  }
}

function* executeReportsPost({ payload: { executeReportsBody } }) {
  try {
    const response = yield call(executeReportsPostApi, executeReportsBody);
    yield put(executeReportsSuccess(response));
  } catch (error) {
    yield put(executeReportsError(error));
  }
}

function* reportExportExcel({ payload: { reportsBody } }) {
  try {
    const response = yield call(reportExportExcelApi, reportsBody);
    yield put(reportExportExcelSuccess(response));
  } catch (error) {
    yield put(reportExportExcelError(error));
  }
}

function* reportsSaga() {
  yield takeEvery(POST_REPORTS, reportsPost);
  yield takeEvery(EXECUTE_REPORT, executeReportsPost);
  yield takeEvery(REPORT_EXPORT_EXCEL, reportExportExcel);
}

export default reportsSaga;
